import script from "./OcrVerificationProductsTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./OcrVerificationProductsTableRow.vue?vue&type=script&setup=true&lang=js"

import "./OcrVerificationProductsTableRow.vue?vue&type=style&index=0&id=772e42dc&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-772e42dc"]])

export default __exports__